'use client';

import { MaterialIconName } from '../../types/materialIconName';
import { useCmsClientContext } from '../../utils/cmsPageContext';
import { getClientTranslations } from '../../utils/translations/getClientTranslations';
import { tr } from '../../utils/translations/tr';
import { CollapsibleSection } from '../CollapsibleSection/CollapsibleSection';
import { RichText } from '../RichText';
import { TranslationKey, TRANSLATIONS } from './i18n';

export type SectionStepsToApplyProps = {
  isVisible: boolean;
  content: string;
  title: TranslationKey;
  icon: MaterialIconName;
  toggleVisibility: () => void;
};

export const SectionStepsToApply: React.FC<SectionStepsToApplyProps> = ({
  isVisible,
  content,
  title,
  icon,
  toggleVisibility,
}) => {
  const context = useCmsClientContext();
  const staticText = getClientTranslations(TRANSLATIONS, context);

  return (
    <CollapsibleSection
      id={`section-steps-to-apply_${title}`}
      isOpen={isVisible}
      onToggle={toggleVisibility}
      iconName={icon}
      iconClassName="overflow-visible size-[18px] md:size-[22px] md:mb-0 md:mr-2"
      content={
        <div className="mx-3 my-spacing/gap/soft-6px p-spacing/gap/soft-12px">
          <RichText className="w-full overflow-x-hidden">
            {content ?? ''}
          </RichText>
        </div>
      }
    >
      <span className="mhg-alpha-bullet-2 lg:mhg-alpha-bullet-1">
        {tr(title, staticText)}
      </span>
    </CollapsibleSection>
  );
};
